import { Observable } from 'rxjs'
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'

import { statusMap } from '@/utils/status-map'

// @ts-ignore
@Component
export default abstract class BaseDialog extends Vue {
    abstract form: any
    abstract rules: any
    public isEdit = false
    @Prop()
    public disabled!: boolean
    @Prop()
    public formProp!: any
    @Prop()
    show!: boolean
    currentPage = 1
    pageSize = 1
    public dialogShow = this.show
    public formShow = false
    selectArray: Array<any> = []

    statusMap = statusMap.createArray()

    get isSelectItem() {
        return this.selectArray.length > 0
    }

    get isSelectOne() {
        return this.selectArray.length === 1
    }

    get title() {
        return this.disabled ? this.$t('common.btn.look') : this.isEdit ? this.$t('common.btn.edit') : this.$t('common.btn.add')
    }

    selectionChange(selectArray: Array<any>) {
        this.selectArray = selectArray
    }

    abstract update(): Observable<any>

    abstract create(): Observable<any>

    abstract onOpen(): any

    public open() {
        this.formShow = true
        this.onOpen()
    }
    // 弹出提示框
    showDialog(title: string, callback: Function) {
        this.$confirm(title, this.$t('hint') as string, {
            confirmButtonText: this.$t('common.btn.confirm') as string,
            cancelButtonText: this.$t('common.btn.cancel') as string,
            type: 'warning'
        }).then(() => {
            callback()
        })
    }
    handleSizeChange(pageSize: number) {
        this.pageSize = pageSize
        this.query()
    }

    handleCurrentChange(currentPage: number) {
        this.currentPage = currentPage
        this.query()
    }

    @Watch('show')
    onShowChanged(newVal: boolean, oldVal: boolean) {
        this.dialogShow = newVal
    }

    @Emit('update:show')
    close() {
        ;(this.$refs['form'] as any).resetFields()
        this.$emit('update:formProp', {})
        this.onClose()
        setTimeout(() => {
            this.formShow = false
        }, 300)
        return false
    }

    reset() {
        ;(this.$refs['form'] as any).resetFields()
    }

    query() {}

    @Watch('disabled')
    disabledChanged(newVal: boolean, oldVal: boolean) {
        this.disabled = newVal
    }

    submit(form: string) {
        ;(this.$refs[form] as any).validate(async (valid: boolean) => {
            if (valid) {
                // TODO 操作成功 显示成功提示信息
                if (this.isEdit) {
                    this.update().subscribe(
                        () => {
                            this.$emit('onUpdate')
                            this.close()
                        },
                        err => {
                            this.$message.warning(err.message)
                        }
                    )
                } else {
                    this.create().subscribe(
                        () => {
                            this.$emit('onAdd')
                            this.close()
                        },
                        err => {
                            this.$message.warning(err.message)
                        }
                    )
                }
            } else {
                return false
            }
        })
    }

    @Watch('formProp')
    onFormPropChanged(newVal: any, oldVal: any) {
        this.isEdit = Object.keys(newVal).length > 0
        for (let formKey in this.form) {
            this.form[formKey] = newVal[formKey] === null || newVal[formKey] === undefined ? '' : newVal[formKey]
        }
    }

    abstract onClose(): any
}
